import { InvoicingCutoffModel } from 'src/app/models/invoicing/invoicing-cutoff.model';
import { BranchModel } from '../management/branch.model';
import { InvoiceEnums } from './../../enum/invoice-enums';
import { InvoiceModel } from './invoice.model';

export class AdvanceInvoiceModel {
  advanceInvoiceId: number = 0;
  invoiceId: number = 0;
  invoice: InvoiceModel = new InvoiceModel();
  branchId: number = 0;
  branch: BranchModel = new BranchModel();
  invoicingCutoffId: number | null = null;
  invoicingCutoffModel: InvoicingCutoffModel | null = null;
  swInvoiceDifference: boolean = false;
  advanceInvoiceState: number = InvoiceEnums.abierta;//cambia por el correspondiente de la enum
  createDate: string = "";
  userNameCreate: string = "";
  updateDate: string | null = null;
  userNameUpdate: string | null = null;
}